module.exports = __webpack_public_path__ + "img/bg_main_sec02.564c6b6e.jpg";